export default __webpack_public_path__ + "static/char-s-62-en-69ea389c4a5fb4f3f42c95158ee6441f.webp";